import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid2,
  Box,
  Button,
} from "@mui/material";
import VideoCall from "@mui/icons-material/VideoCall"; // Ensure this import exists
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import GenerateMeetingMinuteDialog from "./Modal/GenerateMeetingMinuteDialog";
import { useGlobalModalContext } from "../context/GlobalModalContext";

function PreviousMeetings() {
  const { showModal } = useGlobalModalContext();
  const previousMeetingsList = [
    {
      date: "Fri, 20th Dec 2024",
      title: "Meeting with Emma Sri Martini",
      designation: "Director of Finance",
      discussionTopics: [
        {
          description:
            "Followed up discussion on recent financial performance, key metrics and financial health​",
        },
        {
          description:
            "Exploration of  potential projects requiring financing​",
        },
      ],
      actionItems: [
        {
          description: "Follow-up on Overdue Payment​​",
          date: "Due Date: 25 Dec 2024",
        },
        {
          description: "Review Loan Renewal Terms​​",
          date: "Due Date: 27 Dec 2024",
        },
        {
          description: "Send out minutes of meetings​​",
          date: "Due Date: 23 Dec 2024",
        },
      ],
      location: "Conference Call",
      time: "10:00 AM",
    },
  ];

  return (
    <div style={{ height: "40vh", overflowY: "auto" }} className="pt-1 px-2">
      <Box>
      <div className="text-xs text-gray-500 italic flex justify-end mr-2">
          <span className="border-b-2 border-t-2 border-gray-500">
            {" "}
            Illustrative
          </span>
        </div>
        {/* <Grid2
          container
          direction="row"
          my={2}
          sx={{
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            size="small"
            sx={{ textTransform: "none" }}
            onClick={() => showModal(<GenerateMeetingMinuteDialog />)}
            variant="contained"
          >
            Generate Meeting Minutes
          </Button>
        </Grid2> */}
        {previousMeetingsList.map((item, index) => (
          <Box key={index}>
            <Card className="mb-4 shadow-md">
              <CardContent>
                <div
                  className="text-xs font-bold p-2 mb-2 rounded w-[8rem]"
                  style={{ backgroundColor: "lightgray", color: "black" }}
                >
                  {item.date}
                </div>
                <Grid2 container>
                  <Grid2 item size={6}>
                    <div className="flex items-center gap-2">
                      <CalendarMonthOutlinedIcon color="primary" />
                      <div>
                        <div className="text-sm font-bold">{item.title}</div>
                        <div className="text-xs ">{item.designation}</div>
                      </div>
                    </div>
                    <Box className="mt-4">
                      <div className="text-sm font-bold my-2">
                        Discussion Topics
                      </div>
                      <ul className="list-disc ml-6 text-gray-600">
                        {item.discussionTopics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="text-xs">
                            {topic.description}
                          </li>
                        ))}
                      </ul>
                    </Box>
                  </Grid2>
                  <Grid2
                    item
                    size={6}
                    sx={{ borderLeft: "1px solid lightgrey" }}
                  >
                    <Box className="mt-4">
                      <div className="text-sm font-bold my-2 ml-10">
                        Action Items
                      </div>
                      <ul className="list-disc ml-6 text-gray-600 ml-12">
                        {item.actionItems.map((topic, topicIndex) => (
                          <li key={topicIndex} className="text-xs py-1">
                            <div>{topic.description}</div>
                            <div>
                              <i>{topic.date}</i>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </Box>
                  </Grid2>
                </Grid2>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default PreviousMeetings;
